export const addDays = (date, days) => {
    const nextDay = new Date(date);
    nextDay.setDate(date.getDate() + days);
    return nextDay;
}